import { useEffect } from 'react';

import { useStores } from '../../stores/useStores';

import { playerKycWizardFactory } from './PlayerKycWizard/PlayerKycWizard';

const PlayerKycWizard = playerKycWizardFactory({
  trigger: 'manualPush',
  onBeforePersonalDetailsOpened: (stores) => {
    stores.portalStore.closePortal({ preventBeforeClose: true });
  },
  onAfterPersonalDetailsClosed: (stores) => {
    stores.portalStore.openPortal(PlayerKycWizard);
    stores.wizardStore.initialStep = 1;
  },
  onMessage: (data) => {
    if (data.checkStatus === 'success') {
      // Give the player several seconds to see they've succeeded
      setTimeout(() => data.stores.portalStore.closePortal(), 2000);
    }
  },
  onClose: (stores) => stores.portalStore.closePortal(),
});

export function useForceKycReactionDialog() {
  const { forceKycStore } = useStores();

  useEffect(() => {
    forceKycStore.ForceKycReactionComponent = PlayerKycWizard;
  }, [forceKycStore]);
}
